<template>
  <Modal @close="closeModalLocal" :wide="true" width="1900px">

    <table>
      <tbody>
        <tr>
          <td>ID: </td>
          <td>{{order.id}}</td>
        </tr>
        <tr>
          <td>Ankomst: </td>
          <td>{{order.arrival}}</td>
        </tr>
        <tr>
          <td>Avresa: </td>
          <td>{{order.departure}}</td>
        </tr>
        <tr>
          <td>Skapad: </td>
          <td>{{order.created_at | date('short-with-full-time')}}</td>
        </tr>
        <tr>
          <td>Uppdaterad: </td>
          <td>{{order.updated_at | date('short-with-full-time')}} &nbsp; &nbsp; / &nbsp; &nbsp; {{order.touched_at | date('short-with-full-time')}}</td>
        </tr>
        <tr>
          <td>Kommer att avbokas (när inte betald): </td>
          <td>{{order.valid_to_when_unpayed | date('short-with-full-time')}}</td>
        </tr>
        <tr>
          <td>Kort-ID: </td>
          <td>{{order.ext_chip_hash}}</td>
        </tr>
        <tr>
          <td>Betal-ID: </td>
          <td>
            {{order.ext_klarna_id}}
            <!-- /
            <a :href="'http://' + url + '#/betala/bekraftelse?checkout_session_id=' + order.ext_klarna_id" target="_blank">Öppna bekräftelsesidan för att tvinga in ordern</a> -->
          </td>
        </tr>
        <tr>
          <td>Betalstatus: </td>
          <td>{{order.pretty_klarna_status || '-'}} ({{order.ext_klarna_status || '-'}})</td>
        </tr>
        <tr>
          <td>Status: </td>
          <td>{{order.pretty_status || '-'}} ({{order.status || '-'}})</td>
        </tr>
        <tr>
          <td>Ordernummer: </td>
          <td>{{order.number}} {{ order.ext_r360_id ? ' / ' + order.ext_r360_id : '' }}</td>
        </tr>
        <tr>
          <td>Fel: </td>
          <td>{{order.has_error ? 'Ja' : '-'}}</td>
        </tr>
        <tr>
          <td>Felkod: </td>
          <td>{{order.error_code}}</td>
        </tr>
        <tr>
          <td>Betalmetod: </td>
          <td>{{order.payment_method}} - {{order.sub_payment_method}}</td>
        </tr>
        <tr>
          <td>Orderkälla: </td>
          <td>{{order.order_source}}</td>
        </tr>
        <tr>
          <td>Summa: </td>
          <td>{{order.line_sum | currency}}</td>
        </tr>
        <tr>
          <td>PIN: </td>
          <td>{{order.pincode}}</td>
        </tr>
        <tr>
          <td>Synkad till r360: </td>
          <td>{{order.synced_with_r360 ? 'Ja' : 'Nej'}}</td>
        </tr>
        <tr>
          <td>Säkerhetskontroll - har bytt kund: </td>
          <td>{{order.status_customer_set ? 'Ja' : 'Nej'}}</td>
        </tr>
        <tr>
          <td>Säkerhetskontroll - betalslagen: </td>
          <td>{{order.status_fully_payed ? 'Ja' : 'Nej'}}</td>
        </tr>
        <tr>
          <td>Avbokad: </td>
          <td>{{order.canceled ? 'Ja' : 'Nej'}}</td>
        </tr>
        <tr>
          <td>IP: </td>
          <td>{{order.user_ip}}</td>
        </tr>
        <tr>
          <td>User agent: </td>
          <td>{{order.user_ua}}</td>
        </tr>
        <tr>
          <td>Användare: </td>
          <td>{{order.user ? order.user.ext_r360_id : '-'}}</td>
        </tr>
      </tbody>
    </table>

    <table>
      <thead>
        <tr>
          <th>Typ</th>
          <th>Produkt</th>
          <th>ID</th>
          <th>Åld.</th>
          <th>Ankomst</th>
          <th>Tid</th>
          <th>Avresa</th>
          <th>Ant.</th>
          <th>Pris st.</th>
          <th>Pris 360</th>
          <th>DBID</th>
          <th>Namn</th>
          <th>Skostl.</th>
          <th>Vikt</th>
          <th>Längd</th>
          <th>Utkörn.</th>
          <th>Önskm.</th>
          <th>Tfn</th>
          <th>Plats</th>
          <th>Målsman</th>
          <th>Fskrng</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="line in order.lines">
          <td>{{line.pretty_type}}</td>
          <td>{{line.name}}</td>
          <td>{{line.lid}}</td>
          <td>{{line.age}}</td>
          <td>{{line.arrival}}</td>
          <td>{{line.time}}</td>
          <td>{{line.departure}}</td>
          <td>{{line.quantity}}</td>
          <td>{{line.price_per_piece | currency}}</td>
          <td>{{line.ext_price | currency}}</td>
          <td>{{line.period_dbid}}</td>
          <td>{{line.person_name}}</td>
          <td>{{line.person_shoesize}}</td>
          <td>{{line.person_weight}}</td>
          <td>{{line.person_length}}</td>
          <td>{{line.delivery}}</td>
          <td>{{line.wishes}}</td>
          <td>{{line.phone}}</td>
          <td>{{line.site}}</td>
          <td>{{line.guardian}}</td>
          <td>{{line.insurance}}</td>
        </tr>
      </tbody>
    </table>

    <h4>Statusändringar</h4>
    <table>
      <thead>
        <tr>
          <th>När</th>
          <th>Ny status</th>
          <th>Bytt kund (1)</th>
          <th>Betalslagen (1)</th>
          <th>Bytt kund (2)</th>
          <th>Betalslagen (2)</th>
          <th>Felkod</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(change, key) in changes">
          <td>{{change.created_at | date('short-with-full-time')}}</td>
          <td>{{change.pretty_status !== (changes[key + 1] ? changes[key + 1].pretty_status : '---') ? change.pretty_status : ''}}</td>
          <td>{{change.safety_status_customer_set !== (changes[key + 1] ? changes[key + 1].safety_status_customer_set : null) ? 'Ja' : ''}}</td>
          <td>{{change.safety_status_fully_payed !== (changes[key + 1] ? changes[key + 1].safety_status_fully_payed : null) ? 'Ja' : ''}}</td>
          <td>{{change.status_customer_set !== (changes[key + 1] ? changes[key + 1].status_customer_set : null) ? 'Ja' : ''}}</td>
          <td>{{change.status_fully_payed !== (changes[key + 1] ? changes[key + 1].status_fully_payed : null) ? 'Ja' : ''}}</td>
          <td>{{change.error_code}}</td>
        </tr>
      </tbody>
    </table>

  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import API from '@/classes/API';

import Modal from '@/components/components/Modal';

export default {
  components: {
    Modal,
  },
  data() {
    return {
      order: {},
      changes: {},
    };
  },
  async mounted() {
    this.fetch();
  },
  computed: {
    url() {
      return window.location.host + window.location.pathname;
    },
  },
  methods: {
    ...mapMutations([
      'openModal',
    ]),
    async fetch() {
      const { data, changes } = await API.get(`/stats/orders/${this.$route.params.orderId}`);
      this.order = data;
      this.changes = changes;
    },
    closeModalLocal() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

table
  width 98%
  margin-left 1%
th, td
  text-align left
  padding 6px 5px
  white-space: nowrap;
  //border-bottom 1px solid #eeeeee
table tbody tr
  &.warning
    background-color: lightyellow
  &.error
    background-color: pink
td.mark
  font-weight: bold
tr:nth-child(2n)
  background-color #f7f7f7

.flex
  display flex
</style>



// WEBPACK FOOTER //
// OrderSingle.vue?31be6c87